import axios from 'axios';
import qs from 'qs';
import baseURL from './api_url/baseURL.js';
import {Toast} from 'vant';
//设置默认请求路径
// axios.defaults.baseURL = baseURL.http;
// 香港手信
axios.defaults.baseURL = baseURL.httpHK;
//设置默认请求头
axios.defaults.headers.post['Content-Type'] = 'application/json;';// charset=utf-8


// axios 拦截器
axios.interceptors.request.use(config => {
    return config;
  },
  error => {
    return Promise.reject(error);
  });
// 响应
axios.interceptors.response.use(res => {
    return Promise.resolve(res);
  },
  error => {
    Toast({
      message: "当前网络异常，请稍后再试！",
      duration: 1500,
      forbidClick: true
    });
    return Promise.reject(error);
  });

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const get = (url, ...params) => {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const post = (url, ...params) => {
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify(...params))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
};


export default axios



// WEBPACK FOOTER //
// ./src/common/axios.js